import React from 'react'
import PropTypes from 'prop-types'
import { Link, useStaticQuery, graphql } from 'gatsby'

import Layout from '../components/Layout'
import { MetaData } from '../components/common/meta'
import TimeAgo from '../components/TimeAgo'

function NotFound({ location }) {
  const {
    allGhostPost: { nodes: recentPosts },
  } = useStaticQuery(graphql`
    query NotFoundQuery {
      allGhostPost(sort: { published_at: DESC }, limit: 5) {
        nodes {
          ...GhostPostFields
        }
      }
    }
  `)

  return (
    <>
      <MetaData title="Page Not Found" location={location} />
      <Layout sidebar>
        <div className="container">
          <div className="flex justify-center">
            <div id="left-area" className="max-w-3xl flex-1">
              <article className="et_pb_post not_found">
                <div className="entry">
                  <h1>Page Not Found</h1>
                  <p>
                    The page you requested could not be found. Use the
                    navigation above or return to our{' '}
                    <Link to="/">home page</Link>.
                  </p>
                </div>
              </article>
            </div>
            <div id="sidebar">
              <div className="et_pb_widget rpwe_widget recent-posts-extended">
                <h4 className="widgettitle">Recent Posts</h4>
                <div className="rpwe-block">
                  <ul className="rpwe-ul">
                    {recentPosts.map((post) => (
                      <li key={post.id} className="rpwe-li rpwe-clearfix">
                        <h3 className="rpwe-title">
                          <Link
                            to={`/${post.slug}`}
                            title={post.title}
                            rel="bookmark"
                          >
                            {post.title}
                          </Link>
                        </h3>
                        <TimeAgo
                          className="rpwe-time published"
                          dateTime={post.published_at}
                        />
                        <div className="rpwe-summary">
                          {post.excerpt}{' '}
                          <Link to={`/${post.slug}`}>Read More »</Link>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  )
}

NotFound.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
}

export default NotFound
